module.exports = __webpack_public_path__ + "img/18.problem_shower.b48c6dfd.svg";